export default __webpack_public_path__ + "static/media/8-EarlyEveningWalk.59131a98.jpeg";